'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $stateParams, $scope, Upload, toaster, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
    this.$state = $state;
  }

  $onInit() {
    this.getCarousel(this.$stateParams.id);

    this.$scope.$watch('csCtrl.file', (file) => {
      console.log(file);
      if (file !== undefined && file !== null) {
        this.uploadImage(file);
      }
    });
  }

  getCarousel(id) {
    this.$http.get('/api/carousels/' + id).then(res => {
      this.carousel = res.data;
    });
  }

  uploadImage(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/carousels/${this.$stateParams.id}/uploadFile`,
      file: file,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.carousel = data;
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  deleteImg(id) {
    this.$http.get(`/api/carousels/${this.$stateParams.id}/removeItem`, {params: {item: id}})
      .then(res => {
        this.carousel = res.data;
      });
  }

  update() {
    this.$http.put(`/api/carousels/${this.carousel._id}`, this.carousel).then(res => {
      this.$state.go('carousel.show', {
        id: res.data._id
      });
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/carousel/show/show.controller.js